<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 20">
    <g clip-path="url(#clip0_6892_9027)">
      <path
        d="M9.99967 0.960449C4.94183 0.960449 0.833008 5.06927 0.833008 10.1271C0.833008 15.185 4.94183 19.2938 9.99967 19.2938C15.0575 19.2938 19.1663 15.185 19.1663 10.1271C19.1663 5.06927 15.0575 0.960449 9.99967 0.960449ZM9.99967 18.2153C5.53497 18.2153 1.91144 14.5918 1.91144 10.1271C1.91144 5.66241 5.53497 2.03888 9.99967 2.03888C14.4644 2.03888 18.0879 5.66241 18.0879 10.1271C18.0879 14.5918 14.4644 18.2153 9.99967 18.2153ZM10.5502 13.9023H11.607V14.9807H8.41489V13.9023H9.47175V9.13564H8.44724V8.05721H10.5502V13.9023ZM8.58743 5.94348C8.58743 5.35034 9.06194 4.87583 9.65508 4.87583C10.2482 4.87583 10.7119 5.35034 10.7119 5.94348C10.7119 6.53662 10.2374 7.00034 9.65508 7.00034C9.07273 7.00034 8.58743 6.52583 8.58743 5.94348Z"
        :class="colorClass"
      />
    </g>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
